// src/contexts/CartContext.js

import React, { createContext, useState, useEffect, useCallback } from 'react';

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([]);

  useEffect(() => {
    const storedCart = JSON.parse(localStorage.getItem('cart')) || [];
    setCartItems(storedCart);
  }, []);

  useEffect(() => {
    localStorage.setItem('cart', JSON.stringify(cartItems));
  }, [cartItems]);

  const addToCart = useCallback((product, quantityOrWeight = 1) => {
    setCartItems((prevItems) => {
      const existingItem = prevItems.find((item) => item.id === product.id);
  
      // Dynamically determine the correct price
      const currentPriceData = product.current_price || product.price;  // Use `current_price` method
      const priceToUse = currentPriceData.price || product.price;  // Promotional or original price
      const minPurchase = currentPriceData.min_purchase_quantity || product.min_purchase_quantity || 1;
  
      let newQuantityOrWeight = Math.max(quantityOrWeight, minPurchase);
  
      if (existingItem) {
        return prevItems.map((item) =>
          item.id === product.id
            ? {
                ...item,
                price: priceToUse,
                quantity: product.isPrePacked 
                  ? item.quantity + newQuantityOrWeight 
                  : undefined,
                selectedWeight: !product.isPrePacked 
                  ? item.selectedWeight + newQuantityOrWeight 
                  : undefined,
                weight_unit: product.weight_unit,
                min_purchase_quantity: currentPriceData.min_purchase_quantity,
                min_purchase_unit: currentPriceData.min_purchase_unit,
              }
            : item
        );
      } else {
        return [
          ...prevItems,
          {
            ...product,
            price: priceToUse,
            quantity: product.isPrePacked ? newQuantityOrWeight : undefined,
            selectedWeight: !product.isPrePacked ? newQuantityOrWeight : undefined,
            isPrePacked: product.isPrePacked,
            weight_unit: product.weight_unit,
            min_purchase_quantity: currentPriceData.min_purchase_quantity,
            min_purchase_unit: currentPriceData.min_purchase_unit,
          },
        ];
      }
    });
  }, []);
  
  const updateQuantity = useCallback((id, newQuantityOrWeight) => {
    setCartItems((prevItems) =>
      prevItems.map((item) => {
        if (item.id === id) {
          const minPurchase = item.min_purchase_quantity || (item.isPrePacked ? 1 : 0.5);
          const updatedValue = Math.max(newQuantityOrWeight, minPurchase);
          
          return {
            ...item,
            quantity: item.isPrePacked ? updatedValue : item.quantity,
            selectedWeight: !item.isPrePacked ? updatedValue : item.selectedWeight
          };
        }
        return item;
      })
    );
  }, []);

  // const updateQuantity = useCallback((id, newQuantityOrWeight) => {
  //   setCartItems((prevItems) =>
  //     prevItems.map((item) => {
  //       const minPurchase = item.min_purchase_quantity || 1;
  //       const updatedValue = Math.max(newQuantityOrWeight, minPurchase);  // Respect minimum purchase
  //       return {
  //         ...item,
  //         quantity: item.isPrePacked ? updatedValue : item.quantity,  // Update quantity for pre-packed items
  //         selectedWeight: !item.isPrePacked ? updatedValue : item.selectedWeight,  // Update weight for weight-based items
  //       };
  //     })
  //   );
  // }, []);

  const removeFromCart = useCallback((id) => {
    setCartItems(prevItems => prevItems.filter(item => item.id !== id));
  }, []);

  
  const clearCart = useCallback(() => {
    setCartItems([]);
  }, []);

  return (
    <CartContext.Provider
      value={{
        cartItems,
        cartCount: cartItems.length,
        addToCart,
        removeFromCart,
        updateQuantity,
        clearCart,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};